import { TCountIndicatorColorName, TTextWarningTypes } from './types'

export const CHARACTERS_WARNING_STATE = 'warning'
export const CHARACTERS_ERROR_STATE = 'error'

const COUNT_INDICATOR_COLOR_MAP: Record<
  TTextWarningTypes,
  TCountIndicatorColorName
> = {
  [CHARACTERS_ERROR_STATE]: 'accentRed',
  [CHARACTERS_WARNING_STATE]: 'warningColor'
}

export const getCountIndicatorColorName = (
  state: TTextWarningTypes | null
): TCountIndicatorColorName =>
  COUNT_INDICATOR_COLOR_MAP[state as TTextWarningTypes] ?? 'secondarySemiLight'
